import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import cx from 'classnames'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

const getPathToActive = (subMenu) => {
    let currentSubMenu = subMenu
    let pathToActive = [_.get(_.first(subMenu), 'key', null)]

    while (!_.isEmpty(_.get(_.first(currentSubMenu), 'subMenu', []))) {
        currentSubMenu = _.get(_.first(currentSubMenu), 'subMenu', [])
        pathToActive = [...pathToActive, _.get(_.first(currentSubMenu), 'key', null)]
    }

    return pathToActive
}

@hocConnect
export default class Item extends Component {
    static propTypes = {
        activeItem: PropTypes.func.isRequired,
        hasRights: PropTypes.func.isRequired,
        indent: PropTypes.number,
        item: PropTypes.object,
        path: PropTypes.array.isRequired,
        selected: PropTypes.array.isRequired,
        toggles: IPropTypes.map.isRequired,
        toggleSubmenu: PropTypes.func.isRequired,
    }

    static defaultProps = {
        indent: 0,
        item: {
            subMenu: [],
            textKey: null,
        },
    }

    onClickHandler = () => {
        const { item, path, activeItem, toggleSubmenu } = this.props

        if (!_.isEmpty(item.subMenu)) {
            toggleSubmenu(path, getPathToActive(item.subMenu))
        } else {
            activeItem(path, item.key)
        }
    }

    renderSubmenu = () => {
        const { item, indent, toggles, path, selected, activeItem, toggleSubmenu, hasRights } = this.props

        if (_.isEmpty(item.subMenu)) return null

        const subItems = _.map(item.subMenu, (subMenuItem) => (
            <Item
                key={subMenuItem.key}
                path={[...path, subMenuItem.key]}
                item={subMenuItem}
                indent={indent + 1}
                toggles={toggles}
                selected={selected}
                activeItem={activeItem}
                toggleSubmenu={toggleSubmenu}
                hasRights={hasRights}
            />
        ))

        return <div className={'submenu'}>{subItems}</div>
    }

    render() {
        const { item, indent, toggles, path, selected, hasRights } = this.props

        // if item has restrictions and hasn't rights, return null
        const restrictions = _.get(item, 'restrictionTo', null)
        if (restrictions && !hasRights(restrictions)) return null

        const isToggleOpen = toggles.getIn([...path, 'open'], false)
        const isActive = _.isEqual(path, _.take(selected, indent + 1))

        return (
            <div className={'user-profile-menu-item'} style={{ paddingLeft: `${indent * 10}px` }}>
                <div className={cx('text', isActive && 'active')} onClick={this.onClickHandler}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.${item.key}`} />
                    {!_.isEmpty(item.subMenu) && <span className={cx('arrow', isToggleOpen ? 'expand' : 'collapse')} />}
                </div>
                {isToggleOpen && this.renderSubmenu()}
            </div>
        )
    }
}
